import React from 'react'
import CloseIcon from '../../../../components/Icon/CloseIcon'
import { Button } from '../../../../components/ui/Buttons'

const getLocalOdontogramaLabel = row => {
  const { localOdontograma } = row || {}

  if (localOdontograma?.tipo) {
    return localOdontograma.tipo
  }

  if (localOdontograma?.local === 4 && localOdontograma?.codigo) {
    return 'Dente'
  }

  return localOdontograma?.descricao || '-'
}

export const tussTableHeaderColumns = ({ handleRemoveTuss }) => {
  const columns = [
    {
      Header: 'Tabela',
      field: 'tabela',
      getValue: row => row?.tussView?.tabela || '-',
    },
    {
      Header: 'Código e Descrição',
      field: 'codigoTermo',
      getValue: row => row?.tussView?.codigoTermo || '-',
    },
    {
      Header: 'Dente/Região',
      field: 'localOdontograma',
      getValue: row => getLocalOdontogramaLabel(row),
    },
    {
      Header: 'Face',
      field: 'face',
      getValue: row => row?.face?.label || row?.face || '-',
    },
    {
      Header: 'QTD Us.',
      field: 'quantidadeSolicitadaUnidadeServico',
      getValue: row => row?.quantidadeSolicitadaUnidadeServico || '-',
    },
    {
      Header: 'QTD.',
      field: 'quantidadeSolicitada',
      getValue: row => row?.quantidadeSolicitada || '-',
    },
  ]

  columns.push({
    Header: '',
    isClick: true,
    getValue: (_, index) => (
      <Button 
        id={`prt-gtg-btn-rmv-${index}`}
        size='mini'
        shape='circle' 
        bgColor='#FB7676' 
        onClick={() => handleRemoveTuss(index)}
        style={{ height: '25px', width: '25px' }}
      >
        <CloseIcon color='white' size={10} />
      </Button>
    ),
  })

  return columns
}
